module.exports = __webpack_public_path__ + "img/chat_noGroup.ca0f7bdd.png";